import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
  onClick?: () => void;
}
export function Card({
  children,
  className = '',
  hoverEffect = false,
  onClick
}: CardProps) {
  return <div className={`bg-white rounded-3xl p-6 shadow-xl shadow-gray-100 border border-gray-50 ${hoverEffect || onClick ? 'hover-lift cursor-pointer' : ''} ${className}`} onClick={onClick} data-id="element-184" data-mp="8adl1jm47lp0">
      {children}
    </div>;
}